module.exports = __webpack_public_path__ + "img/top-gifter-2.fef5a72c.svg";